import FlightGroupDaysShiftArrival from './flight-group-days-shift-arrival-component';
import FlightGroupDaysShiftArrivalService from './flight-group-days-shift-arrival-service';

const MODULE_NAME = 'app.flight.segment.group.days-shift-arrival';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightGroupDaysShiftArrival.DIRECTIVE_NAME, FlightGroupDaysShiftArrival)
    .service('flightGroupDaysShiftArrivalService', FlightGroupDaysShiftArrivalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-days-shift-arrival/flight-group-days-shift-arrival-module.js